module.exports = __webpack_public_path__ + "static/media/02_hero_mobile.61891463.jpg";